<template lang="pug">
  div.registry.operators
    e-toolbar(
      :items="items"
      @deleteItems="deleteItems"
      :hideRemoveButton="true"
      :showTotal="true"
      :showExport="true"
      :endpointExport="getExportEndpoint()"
      @showMemberChoose="showCreateModal = true"
      :roleTypes="roles"
      @changeRoles="changeRoles"
    )
    e-table(
      :items="items"
      @deleteItem="deleteItem"
      @editItem="editItem"
      :showCheckbox="false"
      idKeyName="originalId"
    )
    member-type(
      v-if='showCreateModal'
      @close="showCreateModal = false"
    )
    router-view
</template>

<script>
import { tko, export_document, owner } from '@/api/api-endpoints'
import tableMixin from '@/components/table/table-mixin'
import hasMixin from '@/mixins/has-mixin'
import url from '@/utils/url'
import MemberType from './components/member-type'
import { REGION_CONFIG } from '@/config/regions'

export default {
  components: { MemberType },
  mixins: [tableMixin, hasMixin],
  data: () => ({
    showCreateModal: false,
    roles: [],
    filteredItems: { data: [], _meta: {} },
  }),
  watch: {
    items(val) {
      this.filteredItems = val
    },
  },
  methods: {
    getEndpoint(route) {
      if (REGION_CONFIG.hasMemberChoose) {
        return owner.ownerOperators(route)
      }
      return tko.operators(route)
    },
    getDeleteUrl(id, item) {
      if (typeof item.type !== 'undefined') {
        if (item.type.code === 'owner') {
          return owner.ownerDelete(id)
        }
      }
      return tko.operatorDelete(id)
    },
    getExportEndpoint() {
      return export_document.tkoOperator(this.$route)
    },
    async changeRoles(roles) {
      let route = url.getRoute(this.$route)
      route.query.type = roles.join()

      this.$router.push(route)

      this.filteredItems = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: owner.ownerOperators(this.$route, roles.join()),
        })
      ).data
    },
  },
  created() {
    if (REGION_CONFIG.hasMemberChoose) {
      this.items.data.forEach((item) => {
        item.originalId = item.type.code + '-' + item.id
      })
    }
  },
}
</script>
